// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2AB-V","subheader":"ReorderModal_subheader__aVjP-","listWrap":"ReorderModal_listWrap__3RqCx"};